const touristTaxWidget = (function () {
	const resultText = document.getElementById('ctt-cms'),
		bannerStep1Text = resultText.getAttribute('data-banner-step-1-text'),
		bannerStep2Text = resultText.getAttribute('data-banner-step-2-text'),
		selectCountryText = resultText.getAttribute('data-dropdown-select-country'),
		selectCityText = resultText.getAttribute('data-dropdown-select-city'),
		touristTaxTitle = resultText.getAttribute('data-result-tourist-tax-cost-title'),
		touristTaxNotesTitle = resultText.getAttribute('data-result-tourist-tax-notes');

	async function init() {
		const data = await fetch(document.getElementById('ctt-json').getAttribute('data-json-path'));
		const jsonData = await data.json();

		jsonData.sort((a, b) => sortByString(a.country, b.country));

		const calc = document.getElementById('cnfsd-ctt-widget'),
			form = document.getElementById('cnfsd_ctt-form'),
			claimResult = document.getElementById('cnfsd_ctt-result'),
			bannerStep = calc.querySelector('.banner-current-progress'),
			bannerText = calc.querySelector('.banner-current-text'),
			countryDropdown = document.getElementById('cnfsd_ctt-country'),
			cityDropdown = document.getElementById('cnfsd_ctt-city'),
			cityDropdownField = document.getElementById('cnfsd_ctt-city-field'),
			continueButton = document.getElementById('cnfsd_ctt-continue'),
			restartButton = calc.querySelector('a.arrow-link--back'),
			totalBannerSteps = 2;

		function calculateBannerProgress() {
			const progress = document.querySelector('.banner__progress-bar__bar'),
				//CALC WIDTH OF EACH STEP IN THE PROCESS
				stepWidth = `${(100 / totalBannerSteps) * parseInt(bannerStep.innerHTML)}%`;
			/* eslint-disable-next-line no-restricted-properties */
			progress.style.width = stepWidth;
		}

		calculateBannerProgress();

		function restartCalc() {
			countryDropdown.innerHTML = `<option selected="selected" disabled="disabled" value="">${selectCountryText}</option>`;
			cityDropdown.innerHTML = `<option selected="selected" disabled="disabled" value="">${selectCityText}</option>`;
			cityDropdownField.classList.add('display-none');
			continueButton.classList.add('display-none');
			swapUi();
			bannerStep.innerHTML = 1;
			bannerText.innerHTML = bannerStep1Text;
			calculateBannerProgress();
			populateCountryDropdown();
		}

		function populateCountryDropdown() {
			jsonData.forEach(item => {
				const option = document.createElement('option');
				option.value = item.country;
				option.text = item.country;
				countryDropdown.appendChild(option);
			});

			// Add event listener to populate the class when a airline is selected
			countryDropdown.addEventListener('change', function () {
				populateCityDropdown(this.value);
			});
		}

		function populateCityDropdown(selectedCountry) {
			// Clear the current options
			cityDropdown.innerHTML = `<option selected="selected" disabled="disabled" value="">${selectCityText}</option>`;

			// Find the selected airline's class and populate the dropdown
			const selectedCountryData = jsonData.find(item => item.country === selectedCountry);
			if (selectedCountryData && selectedCountryData.cities[0].city !== null) {
				selectedCountryData.cities.sort((a, b) => sortByString(a.city, b.city));

				selectedCountryData.cities.forEach(cityItem => {
					const option = document.createElement('option');
					option.value = cityItem.city;
					option.text = cityItem.city;
					cityDropdown.appendChild(option);
				});
				cityDropdownField.classList.remove('display-none');
				cityDropdown.addEventListener('change', function () {
					continueButton.classList.remove('display-none');
				});
			} else {
				continueButton.classList.remove('display-none');
			}
		}

		function showResult() {
			const touristTaxResult = document.getElementById('touristTax-result');
			const selectedCountry = countryDropdown.value;
			const selectedCity = cityDropdown.value;

			// Find the selected country and city
			const selectedCountryData = jsonData.find(item => item.country === selectedCountry);
			const selectedCityData = selectedCountryData.cities.find((item, index) =>
				!selectedCity ? index === 0 : item.city === selectedCity
			);

			const countryCityTitle = `${selectedCountry} - ${selectedCity}`;
			let touristTaxCostHTML = '';
			let additionalNotesHTML = '';

			if (selectedCityData.value !== '') {
				touristTaxCostHTML = `
					<h6>${touristTaxTitle}</h6>
					<ul>
						<li>${selectedCityData.value} ${selectedCityData.extraInformation}</li>
					</ul>				
				`;
			}

			if (selectedCityData.additionalNotes !== '') {
				additionalNotesHTML = `
					<h6>${touristTaxNotesTitle}</h6>
					<ul>
						<li>${selectedCityData.additionalNotes}</li>
					</ul>				
				`;
			}

			const touristTaxHTML = `
			<div class="card--light">
				<h2 class="icon--before travel-icon--pound-symbol--colour">${countryCityTitle}</h2>
				${touristTaxCostHTML}
				${additionalNotesHTML}
			</div>
			`;

			touristTaxResult.innerHTML = touristTaxHTML;

			claimResult.classList.remove('display-none');
			form.classList.add('display-none');
			bannerStep.innerHTML = 2;
			bannerText.innerHTML = bannerStep2Text;
			calculateBannerProgress();
		}

		function swapUi() {
			claimResult.classList.toggle('display-none');
			form.classList.toggle('display-none');
		}

		populateCountryDropdown();

		continueButton.addEventListener('click', function (e) {
			e.preventDefault();
			showResult();
		});

		restartButton.addEventListener('click', e => {
			e.preventDefault();
			restartCalc();
		});
	}

	function sortByString(a, b) {
		if (a < b) {
			return -1;
		}
		if (a > b) {
			return 1;
		}
		return 0;
	}

	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', function () {
	touristTaxWidget.init();
});
